import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['You want ready-to-go activities without a planning spiral', 'Your child loves asking “why?” and making things with their hands', 'You want fewer passive screens and more real-world creativity', 'You need to know the materials, time, and help level before you start', 'You want projects that feel fun because kids are actually doing something'];
const notForYou = ['You are looking for a shipped physical STEM kit', 'You want advanced robotics, coding, or a full video course', 'You only want passive worksheets or watch-only activities', 'You do not want to use basic household or recycled materials'];
export function AudienceSection() {
  return <section className="w-full bg-ivory px-5 py-12 sm:py-20" data-id="element-9" data-mp="3cr3fbxwpky09">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-10" data-mp="3cqk0wr69orqz">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-blue/15 bg-blueprint p-6 sm:p-8" data-id="element-11" data-mp="3hovar1wkb297">
          <h3 className="mb-6 text-lg font-bold text-blue-deep sm:text-xl" data-id="element-12" data-mp="uk7qmf2kopc9">
            ✓ This is for you if…
          </h3>
          <ul className="space-y-4" data-id="element-13" data-mp="qiw9yz1ofeg7">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-14" data-mp="llckt43fxh9h">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal/15 text-teal" data-id="element-15" data-mp="gl83jbupkii7">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-16" data-mp="blddfairbwy7" />
                </span>
                <span className="text-sm leading-relaxed text-navy/80" data-id="element-17" data-mp="7lbl3rywwfvl">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-spark/20 bg-peach p-6 sm:p-8" data-id="element-18" data-mp="25y22sky9rcmp">
          <h3 className="mb-6 text-lg font-bold text-navy sm:text-xl" data-id="element-19" data-mp="44p6a7egog7f">✕ This is not for you if…</h3>
          <ul className="space-y-4" data-id="element-20" data-mp="3meipkhglqku1">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-21" data-mp="3qiqeofqz22ss">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-spark/15 text-spark-deep" data-id="element-22" data-mp="i25enogbik1t">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-23" data-mp="n0yiep5sywos" />
                </span>
                <span className="text-sm leading-relaxed text-navy/80" data-id="element-24" data-mp="90xjvgd0g1ch">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}